import { FC } from 'react';
import { Box, keyframes } from '@mui/material';
import { tss } from 'tss-react/mui';

const rotate = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(1turn); }
`;

const rotateOpacity = keyframes`
  0% { transform: rotate(0deg); opacity: 0.1; }
  100% { transform: rotate(1turn); opacity: 1; }
`;

const useStyles = tss.create(({ theme }) => ({
  root: {
    position: 'relative',
    display: 'flex',
    height: '100vh',
    width: '100%',
  },
  loading: {
    position: 'absolute',
    left: 'calc(50% - 35px)',
    top: '50%',
    width: 55,
    height: 55,
    borderRadius: '50%',
    boxSizing: 'border-box',
    border: '3px solid transparent',
  },
  effect: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    border: '3px solid transparent',
    borderLeft: `3px solid ${theme.palette.primary.main}`,
    borderRadius: '50%',
    boxSizing: 'border-box',
  },
  effect1: {
    animation: `${rotate} 1s ease infinite`,
  },
  effect2: {
    animation: `${rotateOpacity} 1s ease infinite 0.1s`,
  },
  effect3: {
    animation: `${rotateOpacity} 1s ease infinite 0.2s`,
  },
}));

const Spinner: FC = () => {
  const { classes, cx } = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.loading}>
        <Box className={cx(classes.effect, classes.effect1)} />
        <Box className={cx(classes.effect, classes.effect2)} />
        <Box className={cx(classes.effect, classes.effect3)} />
      </Box>
    </Box>
  );
};

export default Spinner;
